import Vue from 'vue';
import Vuex from 'vuex';

import movies from './modules/movies'
import ticketing from './modules/ticketing'
import VueScrollTo from 'vue-scrollto';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    hasBought: false,
  },
  mutations: {
    setTicketingState: (state, {giftCard, selectedMovie, ticketDetail, selectedShow, paymentData, ticketTypeCount, selectedSeats, countdown, holdId}) => {
      state.ticketing.ticketDetail = ticketDetail;
      state.ticketing.selectedShow = selectedShow;
      state.ticketing.paymentData = paymentData;
      state.ticketing.ticketTypeCount = ticketTypeCount;
      state.ticketing.selectedSeats = selectedSeats;
      state.ticketing.holdId = holdId;
      state.ticketing.giftCard = giftCard || {};
      state.ticketing.countdown = countdown || -2;
      state.movies.selectedMovie = selectedMovie;
      if (selectedSeats && selectedSeats.length) {
        state.ticketing.seats = [];
      }
    },
    ticketBought: (state, value) => {
      state.hasBought = value
    }
  },
  actions: {
    scrollTop() {
      const cancelScroll = VueScrollTo.scrollTo('#app', 500, {})
    },
    ticketBought({commit}) {
      commit('ticketBought', true);
    },
    clearLocalStorage({commit}) {
      localStorage.setItem('changes', '');
      localStorage.setItem('booking', '');
      commit('setTicketingState', {});
    },
    levelChanged({commit, getters, root, state, dispatch}, level) {
      if (state.hasBought) {
        dispatch('clearLocalStorage');
        commit('ticketBought', false);
      }
      const selectedMovie = state.movies.selectedMovie;
      const ticketing = state.ticketing;
      const {ticketDetail, selectedShow, paymentData,
        ticketTypeCount, selectedSeats, holdId, giftCard, 
        countdown} = ticketing;
      if (ticketing.ticketDetail) {
        localStorage.setItem('changes', JSON.stringify({ticketDetail, selectedShow, paymentData,
          ticketTypeCount, selectedSeats, holdId, giftCard, 
          countdown, selectedMovie}));
      } else {
        try {
          const stored = localStorage.getItem('changes');
          if (stored) {
            const changes = JSON.parse(stored);
            if (changes.selectedMovie && window.location.href.includes(changes.selectedMovie.Slug)) {
              commit('setTicketingState', changes);
              if (changes.selectedSeats && changes.selectedSeats.length) {
                dispatch('ticketing/loadTicket', changes.countdown)
              }
              if (changes.countdown > 0) {
                dispatch('ticketing/startCountDown', changes.countdown)
              }
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
  modules:{
    movies: movies,
    ticketing: ticketing
  }
});
